import noBlogImage from "../../assets/no-blog-image.webp";
import Badge from "../Badge.jsx";

const BandPostCard = ({ post, bandSlug, bandName, bandProfileImage }) => {
  if (!post) return null;
  const altText = "Omslagsbild för inlägget: " + post.title;
  const bandUrl = `/music/${bandSlug}`;
  const postUrl = `/music/${bandSlug}/blog/${post.slug}`;
  const badgeType = post.post_type === "Blogg" ? "post-blog" : "post-news";

  return (
    <a
      href={postUrl}
      className="group block relative w-full h-80 rounded-4xl overflow-hidden border border-neutral/60 shadow-lg"
    >
      {/* Background image */}
      {post.image_main ? (
        <img
          className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          src={post.image_main}
          alt={altText}
        />
      ) : (
        <img
          className="absolute inset-0 w-full h-full object-cover grayscale brightness-50 transition-transform duration-500 group-hover:scale-105"
          src={noBlogImage}
          alt="Det finns ingen bild för inlägget"
        />
      )}

      {/* Gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-base-100 via-base-100/50 to-transparent" />

      {/* Type badge top-right */}
      <div className="absolute top-3 right-3 z-10">
        <Badge text={post.post_type} type={badgeType} />
      </div>

      {/* Bottom content */}
      <div className="absolute bottom-0 left-0 right-0 z-10 p-4">
        <h4 className="font-bold text-xl text-white capitalize mb-2 line-clamp-2">
          {post.title}
        </h4>
        <div className="flex items-center justify-between">
          <a
            href={bandUrl}
            onClick={(e) => e.stopPropagation()}
            className="flex items-center gap-2 text-sm text-base-content/70 hover:text-white transition-colors"
          >
            <img
              className="size-7 rounded-full object-cover"
              src={bandProfileImage}
              alt={`Profilbild för ${bandName}`}
            />
            {bandName}
          </a>
          <span className="text-xs text-base-content/50">
            {post.posted_date}
          </span>
        </div>
      </div>
    </a>
  );
};

export default BandPostCard;
